import React, { FC } from 'react';
import { PriorityList } from '../priority-list';
import { EmptyContent } from './_card-empty';
import { useBlockedTasks } from './use-blocked-tasks';

export const Content: FC<{ projectId: number }> = ({ projectId }) => {
  const data = useBlockedTasks(projectId);

  return (
    <>{data.length > 0 ? <PriorityList data={data} /> : <EmptyContent />}</>
  );
};
